
import { useEffect, useState } from "react";
import { getEmployeeList } from "../../api/store";
import { Select } from 'antd';

const SelectEmployee = ({ onEmployeeChange, ip }) => {
    const [employees, setEmployees] = useState([]);

    async function getEmployeeListNew() {
        const res = await getEmployeeList(ip);
        console.log(res);
        setEmployees([
            ...res.data.map((employee) => ({
                id: employee.empleadoID,
                name: employee.nombre,
            })),
        ]);
    }

    useEffect(() => {
        getEmployeeListNew();
    }, []);

    return (
        <Select
            style={{ width: 200 }}
            placeholder="请选择职员"
            onChange={onEmployeeChange}
        >
            {employees.map(employee => (
                <Select.Option key={employee.id} value={employee.id}>
                    {employee.name}
                </Select.Option>
            ))}
        </Select>
    );
};

export default SelectEmployee;
